Kakao.init('52a967e011a6bf31224f0a7e9dcc4d77');
Kakao.isInitialized();

// document.body.addEventListener(`click`, () => {
//   const client_id = `0c4af61413eec7c3cf389bc170efeaf3`;
//   const redirect_uri = `http://localhost`;
//   const ref = window.open(`https://kauth.kakao.com/oauth/authorize?client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=code`, `_blank`, 'location=no');
//   ref.addEventListener(`loadstart`, event => {
//     if (event.url.startsWith(`http://localhost/`)) {
//       const code = event.url.split(`code=`)[1];
//       fetch(`https://kauth.kakao.com/oauth/token?grant_type=authorization_code&client_id=${client_id}&redirect_uri=${redirect_uri}&code=${code}`)
//         .then(res => res.json())
//         .then(json => console.log(json));
//       ref.close();
//     }
//   });
// });